<template>
  <Sidebar />
  <MainContentArea />
  <Modal />
  <SessionExpiryWarning />
</template>

<script>
import Sidebar from '../components/Sidebar.vue'
import MainContentArea from '../components/MainContentArea.vue'
import Modal from '../components/Modal.vue'
import SessionExpiryWarning from '../components/SessionExpiryWarning.vue'
import { mapActions } from "vuex";

const IDLE_TIMEOUT_MS = 60 * 60 * 1000; // warn after 1 hour without mouse/keyboard activity
const IDLE_WARNING_MS = 60 * 1000;      // then log out 1 minute later unless the user stays
export default {
  name: 'Portal',
  data() {
    return {
      inactivityTimer: null,
      warningTimer: null,
      // While the idle warning is up, only its buttons may keep the session;
      // stray mouse movement must not silently cancel the pending logout.
      idleWarningShown: false,
    };
  },
  components: {
    Sidebar,
    MainContentArea,
    Modal,
    SessionExpiryWarning
  },
  methods: {
    ...mapActions({
            showModal: "showModal",
        }),
        startInactivityTimer() {
          this.clearTimers();
          this.inactivityTimer = setTimeout(() => {
            const logoutAt = Date.now() + IDLE_WARNING_MS;
            this.idleWarningShown = true;
            this.showModal({ component: 'AccessTokenWarning', data: {
              screensize: 'md', logoutAt, onConfirm: this.stayLoggedIn, onCancel: this.logout,
            }})
            this.startWarningTimer();
          }, IDLE_TIMEOUT_MS);
        },
        startWarningTimer() {
          this.warningTimer = setTimeout(() => {
            this.logout();
          }, IDLE_WARNING_MS);
        },
        onActivity() {
          if (!this.idleWarningShown) this.resetTimer();
        },
        stayLoggedIn() {
          // Ignore a late confirm (e.g. the modal unmounting after logout already ran).
          if (!this.idleWarningShown) return;
          this.idleWarningShown = false;
          this.resetTimer();
        },
        resetTimer() {
          this.clearTimers();
          this.startInactivityTimer();
        },
        clearTimers() {
          clearTimeout(this.inactivityTimer);
          clearTimeout(this.warningTimer);
        },
        logout() {
          this.idleWarningShown = false;
          this.$store.dispatch('hideModal'); 
          // redirect to login page
          this.$store.dispatch('logout');
        },
  },
  mounted() {
    this.startInactivityTimer();
    window.addEventListener('mousemove', this.onActivity);
    window.addEventListener('keyup', this.onActivity);
  },
  beforeUnmount() {
    this.clearTimers();
    window.removeEventListener('mousemove', this.onActivity);
    window.removeEventListener('keyup', this.onActivity);
  },
  beforeMount(){
    
  }
}
</script>

<style>
</style>